(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[354],{

/***/ "8e0A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Boutique", function() { return Boutique; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var Boutique = function Boutique(_ref) {
  var xRef = _ref.xRef,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["xRef"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 16 16"
  }, props, {
    ref: xRef
  }), __jsx("g", {
    fillRule: "evenodd"
  }, __jsx("path", {
    d: "M10.426 15.115h-5.93c-.905 0-1.67-.533-1.685-1.169l.823-8.397c.66.293 1.884.703 3.562.703 1.327 0 2.7-.257 4.085-.764l.83 8.458c-.015.636-.78 1.169-1.685 1.169m2.493-1.23l-.885-9.022a.42.42 0 0 0-.192-.315.395.395 0 0 0-.36-.031c-1.46.597-2.902.9-4.285.9-2.31 0-3.679-.858-3.692-.866a.395.395 0 0 0-.393-.021.418.418 0 0 0-.225.333l-.885 9.022a.428.428 0 0 0-.002.042c0 1.116 1.12 2.024 2.495 2.024h5.93c1.377 0 2.496-.908 2.496-2.024 0-.014 0-.028-.002-.042"
  }), __jsx("path", {
    d: "M7.98 9.29c.21.238.316.102.484.038.135.263.189 1.457-.693 1.817.023-1.202.035-2.488.035-2.488 0-.034-.028-.044-.053-.041-.241.035-.672.473-1.003.844.181.31.415.031.597-.045 0 .05-.042.937-.023 1.839-.908.071-.763-1.837-.71-2.082.022-.195-.584.237-.885.526.094.176.227.14.394.075-.06.857.522 1.635 1.204 1.617.025.881.114 1.737.362 1.798.033.009.06-.895.08-1.897 1.637-.525 1.014-2.538 1.014-2.538-.031-.113-.275.05-.803.537m.29 3.063l.29.299.29-.299-.29-.3zm-2.7-7.646a.412.412 0 0 0 .406-.418v-1.8c0-.912.718-1.653 1.602-1.653.883 0 1.602.741 1.602 1.652V4.29c0 .231.182.418.405.418a.412.412 0 0 0 .406-.418v-1.8C9.99 1.115 8.908 0 7.578 0c-1.33 0-2.413 1.116-2.413 2.488V4.29c0 .231.182.418.405.418"
  })));
};

/***/ })

}]);